<template>
  <section id="home" class="hero-section">
    <!-- Частицы -->
    <div class="particles-container">
      <div v-for="i in 20" :key="i" class="particle" :style="generateParticleStyle()"></div>
    </div>
    
    <div class="container">
      <div class="content-wrapper">
        <!-- Текстовая часть -->
        <div class="text-content">
          <h1 class="title">
            {{ firstName }} <span>{{ lastName }}</span>
          </h1>
          <p class="description">
            {{ description }}
          </p>
          
          <!-- Специализации в виде стильных тегов -->
          <div class="expertise-tags">
            <div class="tag">Web Developer</div>
            <div class="tag">Marketing Consultant</div>
            <div class="tag">Business Consultant</div>
          </div>
          
          <div class="cta-buttons">
            <a href="#portfolio" class="btn primary">Смотреть работы</a>
            <a href="#contact" class="btn secondary">Связаться</a>
          </div>
          
          <!-- Социальные сети -->
          <div class="social-links">
            <a v-for="social in socialMedia" :key="social.name" :href="social.link" target="_blank" class="social-icon" :aria-label="social.name">
              <component :is="social.icon" />
            </a>
          </div>
        </div>
        
        <!-- Изображение -->
        <div class="image-container">
          <div class="glow-effect"></div>
          <div class="image-wrapper">
            <img 
              :src="profileImage" 
              alt="Профессиональное фото" 
            />
          </div>
          <div class="shape shape-1"></div>
          <div class="shape shape-2"></div>
        </div>
      </div>
      
      <!-- Статистика -->
      <div class="stats-section">
        <div class="stats-grid">
          <div v-for="stat in statistics" :key="stat.label" 
               class="stat-card"
               @mouseenter="startCountAnimation(stat)"
               ref="statCards">
            <div class="stat-value">{{ stat.displayed }}</div>
            <div class="stat-label">{{ stat.label }}</div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HeroSection',
  data() {
    return {
      firstName: 'Ruslan',
      lastName: 'Abkadirov',
      description: 'Превращаю идеи в цифровые решения, которые приносят вашему бизнесу реальную прибыль.',
      profileImage: 'img/profile-image.jpg', // Замените на путь к вашему изображению
      socialMedia: [
        { 
          name: 'GitHub',
          link: 'https://github.com/',
          icon: {
            template: `<svg fill="currentColor" viewBox="0 0 24 24"><path d="M12 0C5.374 0 0 5.373 0 12c0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23A11.509 11.509 0 0112 5.803c1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576C20.566 21.797 24 17.3 24 12c0-6.627-5.373-12-12-12z"/></svg>`
          }
        },
        { 
          name: 'LinkedIn',
          link: 'https://linkedin.com/',
          icon: {
            template: `<svg fill="currentColor" viewBox="0 0 24 24"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>`
          } 
        },
        { 
          name: 'Telegram',
          link: 'https://t.me/',
          icon: {
            template: `<svg fill="currentColor" viewBox="0 0 24 24"><path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/></svg>`
          }
        },
        { 
          name: 'Email',
          link: 'mailto:example@example.com',
          icon: {
            template: `<svg fill="currentColor" viewBox="0 0 24 24"><path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/></svg>`
          }
        }
      ],
      statistics: [
        { value: '12+', label: 'Лет опыта', displayed: '0+', original: '12+' },
        { value: '120+', label: 'Выполненных проектов', displayed: '0+', original: '120+' },
        { value: '98%', label: 'Довольных клиентов', displayed: '0%', original: '98%' },
        { value: '24/7', label: 'Доступность', displayed: '24/7', original: '24/7' }
      ],
      animatingStats: new Set(),
      observerInitialized: false
    }
  },
  mounted() {
    // Инициализация наблюдателя для анимации статистики при прокрутке
    this.initIntersectionObserver();
    
    // Анимация частиц
    this.animateParticles();
  },
  methods: {
    generateParticleStyle() {
      const size = Math.random() * 6 + 2; // от 2px до 8px
      const x = Math.random() * 100; // позиция X в процентах
      const y = Math.random() * 100; // позиция Y в процентах
      const duration = Math.random() * 20 + 10; // от 10s до 30s
      const delay = Math.random() * 5; // задержка до 5s
      const opacity = Math.random() * 0.5 + 0.1; // прозрачность от 0.1 до 0.6
      
      return {
        width: `${size}px`,
        height: `${size}px`,
        left: `${x}%`,
        top: `${y}%`,
        opacity: opacity,
        animationDuration: `${duration}s`,
        animationDelay: `${delay}s`
      };
    },
    
    animateParticles() {
      const particles = document.querySelectorAll('.particle');
      particles.forEach(particle => {
        // Перезапуск анимации при ее завершении
        particle.addEventListener('animationiteration', () => {
          const style = this.generateParticleStyle();
          Object.keys(style).forEach(key => {
            particle.style[key] = style[key];
          });
        });
      });
    },
    
    initIntersectionObserver() {
      if (this.observerInitialized) return;
      
      const options = {
        root: null,
        rootMargin: '0px',
        threshold: 0.5
      };
      
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const index = Array.from(this.$refs.statCards).indexOf(entry.target);
            if (index !== -1) {
              this.startCountAnimation(this.statistics[index]);
            }
          }
        });
      }, options);
      
      // Добавляем наблюдение за карточками статистики
      this.$nextTick(() => {
        if (this.$refs.statCards) {
          this.$refs.statCards.forEach(card => {
            observer.observe(card);
          });
        }
        this.observerInitialized = true;
      });
    },
    
    startCountAnimation(stat) {
      // Пропускаем, если анимация уже запущена или значение не числовое
      if (this.animatingStats.has(stat) || stat.original === '24/7') return;
      
      this.animatingStats.add(stat);
      
      // Парсим числовое значение
      let targetValue = parseInt(stat.original);
      if (isNaN(targetValue)) return;
      
      let suffix = stat.original.replace(/[0-9]/g, '');
      let duration = 2000; // 2 секунды
      let startTime = null;
      
      const animate = (timestamp) => {
        if (!startTime) startTime = timestamp;
        const progress = Math.min((timestamp - startTime) / duration, 1);
        const currentValue = Math.floor(progress * targetValue);
        
        stat.displayed = currentValue + suffix;
        
        if (progress < 1) {
          requestAnimationFrame(animate);
        } else {
          stat.displayed = stat.original;
          this.animatingStats.delete(stat);
        }
      };
      
      requestAnimationFrame(animate);
    }
  }
}
</script>

<style scoped>
.hero-section {
  padding-top: 120px;
  padding-bottom: 40px;
  background-color: #121212;
  overflow: hidden;
  position: relative;
  font-family: 'Arial', 'Helvetica', sans-serif;
}

/* Частицы */
.particles-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  z-index: 1;
}

.particle {
  position: absolute;
  background: linear-gradient(135deg, #64b5f6, #1976d2);
  border-radius: 50%;
  animation: float 15s infinite ease-in-out;
}

@keyframes float {
  0% {
    transform: translateY(0) translateX(0) rotate(0deg);
  }
  25% {
    transform: translateY(-30px) translateX(20px) rotate(90deg);
  }
  50% {
    transform: translateY(-10px) translateX(40px) rotate(180deg);
  }
  75% {
    transform: translateY(-40px) translateX(10px) rotate(270deg);
  }
  100% {
    transform: translateY(0) translateX(0) rotate(360deg);
  }
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  position: relative;
  z-index: 2;
}

.content-wrapper {
  display: flex;
  flex-direction: column;
  gap: 40px;
  margin-bottom: 60px;
}

@media (min-width: 768px) {
  .content-wrapper {
    flex-direction: row;
    align-items: center;
  }
}

/* Текстовая часть */
.text-content {
  flex: 1;
  animation: fadeInUp 1s ease-out;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(40px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Теги специализаций */
.expertise-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 30px;
}

.tag {
  position: relative;
  padding: 7px 15px 7px 12px;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.7px;
  color: #ffffff;
  background: linear-gradient(135deg, rgba(16, 16, 20, 0.8), rgba(45, 45, 55, 0.4));
  border-radius: 3px;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.05);
  display: flex;
  align-items: center;
}

.tag::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 4px;
  background: #64b5f6;
}

.tag:nth-child(2)::before {
  background: #bb86fc;
}

.tag:nth-child(3)::before {
  background: #04dac6;
}

.tag::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(to right, 
               rgba(100, 181, 246, 0.1), 
               transparent);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.tag:nth-child(2)::after {
  background: linear-gradient(to right, 
               rgba(187, 134, 252, 0.1), 
               transparent);
}

.tag:nth-child(3)::after {
  background: linear-gradient(to right, 
               rgba(4, 218, 198, 0.1), 
               transparent);
}

.tag:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.25);
}

.tag:hover::after {
  opacity: 1;
}

.title {
  font-size: 2.5rem;
  font-weight: 700;
  color: #ffffff;
  margin: 0 0 20px 0;
  line-height: 1.2;
  position: relative;
  animation: fade-in 1s ease-out;
  font-family: 'Arial', 'Helvetica', sans-serif;
}

.title span {
  color: #64b5f6;
  position: relative;
  display: inline-block;
}

.title span::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 4px;
  background: linear-gradient(90deg, transparent, #64b5f6, transparent);
  animation: expand 1.5s ease-in-out forwards;
  transform-origin: left;
  transform: scaleX(0);
}

@keyframes expand {
  to {
    transform: scaleX(1);
  }
}

@keyframes fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@media (min-width: 768px) {
  .title {
    font-size: 3.5rem;
  }
}

.description {
  color: #b0bec5;
  font-size: 1.1rem;
  line-height: 1.6;
  margin-bottom: 25px;
  max-width: 600px;
  animation: fadeIn 1.2s ease-in-out;
  font-family: 'Arial', 'Helvetica', sans-serif;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.cta-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 30px;
  animation: fadeInUp 1.4s ease-out;
}

.btn {
  display: inline-block;
  padding: 12px 28px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 1rem;
  text-decoration: none;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  font-family: 'Arial', 'Helvetica', sans-serif;
}

.btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.1);
  transition: all 0.6s ease;
  z-index: -1;
}

.btn:hover::before {
  left: 100%;
}

.btn.primary {
  background-color: #1976d2;
  color: white;
  box-shadow: 0 4px 12px rgba(25, 118, 210, 0.3);
}

.btn.primary:hover {
  background-color: #1565c0;
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(25, 118, 210, 0.4);
}

.btn.secondary {
  background-color: transparent;
  color: #64b5f6;
  border: 2px solid #64b5f6;
}

.btn.secondary:hover {
  background-color: rgba(100, 181, 246, 0.1);
  transform: translateY(-2px);
}

.social-links {
  display: flex;
  gap: 16px;
  animation: fadeInUp 1.6s ease-out;
  margin-top: 5px;
}

.social-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  border-radius: 50%;
  background-color: #1e1e1e;
  color: #ffffff;
  border: 1px solid #333333;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
}

.social-icon::after {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(circle, rgba(100, 181, 246, 0.3), transparent 70%);
  opacity: 0;
  transition: opacity 0.3s;
}

.social-icon:hover {
  color: #64b5f6;
  transform: translateY(-3px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  border-color: #64b5f6;
}

.social-icon:hover::after {
  opacity: 1;
  animation: pulse 2s infinite;
}

.social-icon svg {
  width: 22px;
  height: 22px;
  position: relative;
  z-index: 1;
  fill: currentColor;
}

@keyframes pulse {
  0% {
    transform: scale(0.95);
  }
  50% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(0.95);
  }
}

/* Изображение */
.image-container {
  flex: 1;
  position: relative;
  margin: 0 auto;
  max-width: 400px;
  animation: fadeIn 1.5s ease-out;
}

.glow-effect {
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 16px;
  background: radial-gradient(circle at center, rgba(100, 181, 246, 0.2) 0%, transparent 70%);
  filter: blur(25px);
  z-index: 0;
  animation: glow 5s infinite alternate;
}

@keyframes glow {
  0% {
    opacity: 0.5;
    transform: scale(0.9);
  }
  100% {
    opacity: 0.8;
    transform: scale(1.1);
  }
}

.image-wrapper {
  position: relative;
  z-index: 2;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 16px 32px rgba(0, 0, 0, 0.3);
  background-color: #000;
  transform: perspective(1000px) rotateY(0deg);
  transition: transform 0.5s ease;
  animation: float-image 6s ease-in-out infinite;
}

.image-wrapper:hover {
  transform: perspective(1000px) rotateY(5deg);
}

@keyframes float-image {
  0% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
  100% {
    transform: translateY(0);
  }
}

.image-wrapper img {
  display: block;
  width: 100%;
  height: auto;
  object-fit: cover;
  mix-blend-mode: normal;
  transition: transform 0.3s ease;
}

.image-wrapper:hover img {
  transform: scale(1.03);
}

.shape {
  position: absolute;
  border-radius: 16px;
}

.shape-1 {
  width: 100%;
  height: 100%;
  background-color: rgba(100, 181, 246, 0.2);
  top: 16px;
  right: -16px;
  z-index: 1;
  animation: move-shape 8s ease-in-out infinite alternate;
}

.shape-2 {
  width: 60%;
  height: 70%;
  background-color: rgba(100, 181, 246, 0.1);
  bottom: -12px;
  left: -12px;
  z-index: 1;
  animation: move-shape 8s ease-in-out infinite alternate-reverse;
}

@keyframes move-shape {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(5px, 5px);
  }
}

/* Статистика */
.stats-section {
  padding: 20px 0;
  position: relative;
  z-index: 2;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}

@media (min-width: 768px) {
  .stats-grid {
    grid-template-columns: repeat(4, 1fr);
  }
}

.stat-card {
  background-color: #1e1e1e;
  padding: 20px;
  border-radius: 12px;
  text-align: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  font-family: 'Arial', 'Helvetica', sans-serif;
}

.stat-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, transparent, rgba(100, 181, 246, 0.05), transparent);
  transform: translateX(-100%);
  transition: transform 0.6s ease;
}

.stat-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3);
  background-color: #252525;
}

.stat-card:hover::before {
  transform: translateX(100%);
}

.stat-value {
  font-size: 1.8rem;
  font-weight: 700;
  color: #64b5f6;
  margin-bottom: 8px;
  position: relative;
  font-family: 'Arial', 'Helvetica', sans-serif;
}

.stat-label {
  color: #b0bec5;
  font-size: 0.9rem;
  position: relative;
  font-family: 'Arial', 'Helvetica', sans-serif;
}
</style>